module.exports = __webpack_public_path__ + "static/profile_img-2deecf28c2e0428066b2bd5176ffbeb4.jpeg";